import { render, staticRenderFns } from "./FullDefine_WishList_Mobile.vue?vue&type=template&id=21b1ef8e&scoped=true&"
import script from "./FullDefine_WishList_Mobile.vue?vue&type=script&lang=js&"
export * from "./FullDefine_WishList_Mobile.vue?vue&type=script&lang=js&"
import style0 from "./FullDefine_WishList_Mobile.vue?vue&type=style&index=0&id=21b1ef8e&prod&lang=css&"
import style1 from "./FullDefine_WishList_Mobile.vue?vue&type=style&index=1&id=21b1ef8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b1ef8e",
  null
  
)

export default component.exports